import CircularProgress from "material-ui-old/CircularProgress";
import React, { PureComponent } from "react";
import {
    Col,
    FormControl,
    FormGroup,
    Grid,
    HelpBlock,
    Row
} from "react-bootstrap";
import { isEmpty, isNil } from "lodash";
import { wevosUrl } from "../../helpers/api";
import axios from "axios";
import * as colors from "../../helpers/constants/colors";
import Icon from "../Icon";
import { greyPalette } from "../../helpers/constants/colorPalettes";
import Button from "../Button";
import {
    configureWevoActions,
    configureWevoTypes
} from "../../modules/configure-wevo";
import { MuiThemeProvider } from "material-ui-old/styles";
import ToothpasteTag from "../ToothpasteTag";
import { trackerActions } from "../../modules/tracker";
import { ConfigureProjectEvents } from "../../modules/tracker/event-names";
import { connect } from "react-redux";
import { DEVICES } from "../../modules/devices/constants";

class ProjectDefinition extends PureComponent {
    /*

     Initialization Functions

     */
    constructor(props) {
        super(props);
        this.state = {
            unmounting: false
        };
        this.toNextStep = props.toNextStep;
    }

    componentWillUnmount() {
        const { wevoId, wevo } = this.props;
        this.state.unmounting = true;
        if (wevoId && wevo) {
            this.save();
        }
    }

    componentWillMount() {
        this.props.trackEvent(
            ConfigureProjectEvents.DID_NAVIGATE_TO_PROJECT_DEFINITION
        );
        const state = ProjectDefinition.determineStateFromProps(this.props);
        const renderState = this.determineRenderState(this.props);
        this.state = {
            ...(this.state || {}),
            ...state,
            renderState
        };
    }

    componentWillReceiveProps(nextProps) {
        const state = ProjectDefinition.determineStateFromProps(nextProps);
        const renderState = this.determineRenderState(nextProps);
        this.setState({
            ...(this.state || {}),
            ...state,
            renderState
        });
    }

    static determineStateFromProps(props) {
        const { wevo, entities, loadingState } = props;
        const { devices } = entities;
        return {
            devices,
            testName: wevo ? wevo.name : "",
            description: wevo ? wevo.description : "",
            selectedDevices: wevo
                ? wevo.devices.reduce((acc, device) => {
                      acc[device.id] = true;
                      return acc;
                  }, {})
                : { 1: true },
            testNameUnique: true,
            loadingState
        };
    }

    determineRenderState(props) {
        const { unmounting } = this.state;
        const { wevo, dispatch, loadingStateKey, loadingState } = props;
        let renderState = {
            shouldShowLoading: null,
            shouldShowError: null,
            shouldShowSuccess: null
        };
        let wevoId;
        if (loadingState) {
            if (wevo) {
                const configurationObject = loadingState[wevo.id];
                if (configurationObject) {
                    switch (configurationObject.status) {
                        case configureWevoTypes.REQUEST_SAVE_WEVO:
                            renderState.shouldShowLoading = true;
                            break;
                        case configureWevoTypes.SAVE_WEVO_SUCCESS:
                            renderState.shouldShowSuccess = true;
                            dispatch(
                                configureWevoActions.requestStateClearForKey([
                                    loadingStateKey,
                                    wevo.id
                                ])
                            );
                            break;
                        case configureWevoTypes.SAVE_WEVO_ERROR:
                            renderState.shouldShowError = {
                                err: configurationObject.error
                            };
                            dispatch(
                                configureWevoActions.requestStateClearForKey([
                                    loadingStateKey,
                                    wevo.id
                                ])
                            );
                            break;
                        default:
                            break;
                    }
                }
            } else if (loadingState.createNew) {
                const configurationObject = loadingState.createNew;
                if (configurationObject) {
                    switch (configurationObject.status) {
                        case configureWevoTypes.REQUEST_CREATE_WEVO:
                            renderState.shouldShowLoading = true;
                            break;
                        case configureWevoTypes.CREATE_WEVO_SUCCESS:
                            wevoId = configurationObject.wevoId;
                            renderState.shouldShowSuccess = true;
                            dispatch(
                                configureWevoActions.requestStateClearForKey([
                                    loadingStateKey,
                                    "createNew"
                                ])
                            );
                            break;
                        case configureWevoTypes.CREATE_WEVO_ERROR:
                            renderState.shouldShowError = {
                                err: configurationObject.error
                            };
                            dispatch(
                                configureWevoActions.requestStateClearForKey([
                                    loadingStateKey,
                                    "createNew"
                                ])
                            );
                            break;
                        default:
                            break;
                    }
                }
            }
        }
        if (renderState.shouldShowSuccess && !unmounting) {
            return this.toNextStep(wevoId);
        }
        return renderState;
    }

    /*

     State editor & checker functions

     */

    async checkUniqueTestName(name) {
        const query = {
            name: name
        };
        const { teamId, wevo } = this.props;
        if (name.trim() === "") {
            return true;
        }
        if (!isNil(wevo)) {
            if (name.trim() === wevo.name.trim()) {
                return true;
            }
        }
        const url = wevosUrl(teamId, query);
        try {
            // TODO: Get this up to being an action instead of making a call
            // directly from the component
            const wevoRequest = await axios.get(url);
            if (wevoRequest.status === 200) {
                const responseData = wevoRequest.data;
                const { wevos } = responseData;
                const isUnique = wevos.every(w => {
                    return w.name.trim() !== name.trim();
                });
                return isUnique;
            }
        } catch (err) {
            console.error(err);
            return true;
        }
    }

    isValid() {
        return (
            this.state.testNameUnique &&
            !isEmpty(this.state.testName) &&
            !isEmpty(this.state.selectedDevices)
        );
    }

    async onChange(field, e) {
        const value = e.target.value;
        if (field === "name") {
            this.setState({
                ...this.state,
                testName: value
            });
            const nameIsUnique = await this.checkUniqueTestName(value);
            this.setState({
                ...this.state,
                testNameUnique: nameIsUnique
            });
        } else if (field === "description") {
            this.setState({
                ...this.state,
                description: value
            });
        }
    }

    selectDevice(deviceId, isActive) {
        this.props.trackEvent(
            ConfigureProjectEvents.DID_SELECT_PROJECT_DEVICE,
            {
                device_id: deviceId,
                device_is_selectable: isActive
            }
        );
        if (isActive) {
            this.setState({
                ...this.state,
                selectedDevices: {
                    [deviceId]: true
                }
            });
        }
    }

    /*

     Persistence functions

     */

    save() {
        const { wevo, teamId, isReadOnly } = this.props;
        const { testName, description, selectedDevices } = this.state;
        const { dispatch } = this.props;
        if (isReadOnly) {
            return;
        }
        if (isNil(wevo)) {
            const wevoModificationObject = {
                name: testName,
                description: description || "",
                devices: Object.keys(selectedDevices)
            };
            dispatch(
                configureWevoActions.createWevo(teamId, wevoModificationObject)
            );
        } else {
            const wevoModificationObject = {};
            if (testName && testName !== wevo.name) {
                wevoModificationObject.name = testName;
            }
            if (description && description !== wevo.description) {
                wevoModificationObject.description = description;
            }
            if (
                wevoModificationObject.devices &&
                Object.keys(selectedDevices).join(",") !==
                    wevo.devices.map(d => d.id).join(",")
            ) {
                wevoModificationObject.devices = Object.keys(
                    selectedDevices
                ).join(",");
            }
            if (!isEmpty(wevoModificationObject)) {
                dispatch(
                    configureWevoActions.updateWevo(
                        wevo.id,
                        wevoModificationObject
                    )
                );
            }
        }
    }

    /*

     Rendering Functions

     */

    renderNameFormItem() {
        const { teamId, isReadOnly } = this.props;
        const { testName, testNameUnique } = this.state;
        const validationBlock = () => {
            if (testNameUnique) {
                return null;
            }
            this.props.trackEvent(
                ConfigureProjectEvents.DID_RECEIVE_INVALID_PROJECT_NAME_WARNING,
                {
                    project_name: testName,
                    team_id: teamId
                }
            );
            return (
                <HelpBlock className="error">
                    {testName} already exists. Please choose a unique name.
                </HelpBlock>
            );
        };
        return (
            <FormGroup
                controlId="formTestName"
                validationState={testNameUnique ? null : "error"}
            >
                <FormControl
                    disabled={isReadOnly}
                    type="text"
                    placeholder="Test Name"
                    value={testName}
                    onChange={this.onChange.bind(this, "name")}
                />
                {validationBlock()}
            </FormGroup>
        );
    }

    renderButton() {
        const { nextStepText, wevoId } = this.props;

        if (!this.isValid()) {
            return (
                <Button disabled={true} color="disabled">
                    {" "}
                    {nextStepText}
                </Button>
            );
        }
        return (
            <Button
                onClick={
                    wevoId
                        ? this.props.toNextStep.bind(this, wevoId)
                        : this.save.bind(this)
                }
            >
                {nextStepText}
            </Button>
        );
    }

    render() {
        const { wevoId, isReadOnly, entities, devicesLoaded } = this.props;
        const { renderState, selectedDevices, description } = this.state;
        if (!renderState) {
            return <CircularProgress />;
        }
        if (renderState.shouldShowSuccess) {
            return <CircularProgress />;
        }

        if (renderState.shouldShowLoading || !devicesLoaded) {
            return <CircularProgress />;
        }

        if (renderState.shouldShowError) {
            return <h1>{renderState.shouldShowError.err.message}</h1>;
        }
        const { devices, images } = entities;

        const devicesToDisplay = Object.keys(devices).reduce((acc, key) => {
            const device = devices[key];
            const isSelected = selectedDevices[device.id];
            acc.push({
                ...device,
                isSelected
            });
            return acc;
        }, []);

        const sortedDevices = devicesToDisplay.sort((a, b) => {
            return a.sortOrder - b.sortOrder;
        });

        const labels = this.props.stepLabels;

        return (
            <Grid style={{ width: "100%" }}>
                <Row>
                    <Col xs={6} xsOffset={3}>
                        <h1>{labels.title || labels.leftBar}</h1>
                        <h5>{labels.subtitle || ""}</h5>
                    </Col>
                </Row>
                <MuiThemeProvider>
                    <Row
                        style={{
                            marginLeft: "0px",
                            marginRight: "0px",
                            marginTop: "30px"
                        }}
                    >
                        <Row>
                            <Col xs={4} xsOffset={4}>
                                <form>
                                    {this.renderNameFormItem()}
                                    <FormGroup>
                                        <FormControl
                                            disabled={isReadOnly}
                                            componentClass="textarea"
                                            placeholder="Test Goals (optional)"
                                            value={description}
                                            rows={5}
                                            style={{
                                                resize: "none"
                                            }}
                                            onChange={this.onChange.bind(
                                                this,
                                                "description"
                                            )}
                                        />
                                    </FormGroup>
                                </form>
                            </Col>
                        </Row>
                        <Row
                            style={{
                                marginLeft: "0px",
                                marginRight: "0px"
                            }}
                        >
                            <Col xs={6} xsOffset={3}>
                                <h3>Choose Device</h3>
                            </Col>
                        </Row>
                        <Row
                            style={{
                                margin: "0px"
                            }}
                        >
                            <Col xs={4} xsOffset={4}>
                                <Row>
                                    {sortedDevices.map((d, i) => {
                                        const style = {
                                            backgroundColor: colors.disabled,
                                            color: colors.typography,
                                            padding: "30px",
                                            textAlign: "center",
                                            cursor: isNil(wevoId)
                                                ? "pointer"
                                                : "not-allowed"
                                        };
                                        const isLast =
                                            i === sortedDevices.length - 1;
                                        const isFirst = i === 0;
                                        const iconImage = images[d.iconImage];
                                        const iconImageFile =
                                            iconImage.files.original;
                                        if (d.isSelected) {
                                            style.backgroundColor =
                                                colors.accent;
                                            style.color = colors.white;
                                        }
                                        // You cannot select a device when it isn't active,
                                        // or after you've already created the test, as the pages
                                        // are all created with the initial device associated
                                        // with the test
                                        else if (
                                            !d.isActive ||
                                            !isNil(wevoId)
                                        ) {
                                            style.cursor = "not-allowed";
                                            style.backgroundColor =
                                                greyPalette.lightGrey;
                                            style.color = greyPalette.medGrey;
                                        }
                                        if (isFirst) {
                                            style.borderRadius =
                                                "5px 0px 0px 5px";
                                        } else if (isLast) {
                                            style.borderRadius =
                                                "0px 5px 5px 0px";
                                        }
                                        const comingSoon = () => {
                                            if (!d.isActive) {
                                                return (
                                                    <Row>
                                                        <Col
                                                            xs={10}
                                                            xsOffset={1}
                                                        >
                                                            <ToothpasteTag
                                                                borderRadius={
                                                                    20
                                                                }
                                                                height="40px"
                                                                style={{
                                                                    backgroundColor:
                                                                        colors.white,
                                                                    border: `2px ${
                                                                        greyPalette.medGrey
                                                                    } solid`,
                                                                    color:
                                                                        greyPalette.medGrey,
                                                                    textAlign:
                                                                        "center",
                                                                    marginTop:
                                                                        "-20px",
                                                                    width:
                                                                        "100%"
                                                                }}
                                                                label="COMING SOON"
                                                            />
                                                        </Col>
                                                    </Row>
                                                );
                                            }
                                        };
                                        return (
                                            <Col xs={6} key={d.id}>
                                                <Row>
                                                    <Col
                                                        onClick={
                                                            !wevoId &&
                                                            this.selectDevice.bind(
                                                                this,
                                                                d.id,
                                                                d.isActive
                                                            )
                                                        }
                                                        xs={12}
                                                        style={style}
                                                    >
                                                        {iconImageFile.contentType ===
                                                        "icon/font-awesome" ? (
                                                            React.createElement(
                                                                DEVICES[d.id].icon,
                                                                { size: "5x" }
                                                            )
                                                        ) : (
                                                            <img
                                                                src={
                                                                    iconImageFile.imageUrl
                                                                }
                                                                style={{
                                                                    height:
                                                                        "5rem",
                                                                    width:
                                                                        "5rem"
                                                                }}
                                                            />
                                                        )}
                                                        <h4>{d.name}</h4>
                                                    </Col>
                                                </Row>
                                                {comingSoon()}
                                            </Col>
                                        );
                                    })}
                                </Row>
                            </Col>
                        </Row>
                        <Row
                            style={{
                                marginTop: "30px"
                            }}
                        >
                            <Col xs={4} xsOffset={4}>
                                {this.renderButton()}
                            </Col>
                        </Row>
                    </Row>
                </MuiThemeProvider>
            </Grid>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        trackEvent: (eventName, eventProperties) =>
            dispatch(trackerActions.trackEvent(eventName, eventProperties))
    };
};

export default connect(
    null,
    mapDispatchToProps
)(ProjectDefinition);



// WEBPACK FOOTER //
// ./src/components/CreateTest/ProjectDefinition.js